import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { BadgeColorsEnum } from 'src/app/shared/interfaces/BadgeColorsEnum';
import { DrugActivitiesToTrackEnum } from 'src/app/shared/interfaces/DrugActivitiesToTrackEnum';
import { IC3C5SettingValue } from 'src/app/shared/interfaces/IC3C5SettingValue.interface';
import { DrugsService } from 'src/app/shared/services/drugs.service';
import { PinService } from 'src/app/shared/services/pin.service';
import { EnableC3toC5Drugs, UpdateDrugsToTrack } from 'src/app/shared/states/pharmacy/pharmacy.actions';
import { PharmacyState } from 'src/app/shared/states/pharmacy/pharmacy.state';
import { GetDrugsOfInterest } from 'src/app/shared/states/settings/settings.actions';
import { SettingsState } from 'src/app/shared/states/settings/settings.state';
import { SetDashboardFilters } from 'src/app/shared/states/transactions/transactions.actions';
import { TransactionsState } from 'src/app/shared/states/transactions/transactions.state';
import { IDrugOfInterest } from '../../interfaces/IDrugOfInterest';
import { withLatestFrom } from 'rxjs/operators';
@UntilDestroy()
@Component({
  selector: 'app-enable-c3-c5-setting',
  templateUrl: './enable-c3-c5-setting.component.html',
  styleUrls: ['./enable-c3-c5-setting.component.scss', '../../settings.component.scss'],
})
export class EnableC3C5SettingComponent implements OnInit {

  enableC3toC5Drugs: boolean;
  runEnableC3C5Workflow: boolean;
  editDrugsOfInterest: boolean;

  drugsOfInterest: IC3C5SettingValue;
  enableC3toC5DrugsPinChannel = 'enableC3toC5Drugs';
  editDrugsOfInterestPinChannel = 'editDrugsOfInterest';

  BadgeColorsEnum = BadgeColorsEnum;

  DrugActivitiesToTrackEnum = DrugActivitiesToTrackEnum;
  
  @Select(PharmacyState.enableC3toC5Drugs) enableC3toC5Drugs$: Observable<boolean>;
  @Select(PharmacyState.enableC3toC5DrugsValue) enableC3toC5DrugsValue$: Observable<IC3C5SettingValue>;

  @Select(SettingsState.loading) loading$: Observable<boolean>;
  @Select(SettingsState.drugsOfInterest) drugsOfInterest$: Observable<IDrugOfInterest[]>;

  /**
   *
   */
  constructor(private store: Store, private drugsService: DrugsService, private pinService: PinService) {
    
  }

  ngOnInit(): void {
    this.enableC3toC5Drugs$
    .pipe(untilDestroyed(this))
    .subscribe((val) => this.enableC3toC5Drugs = val);

    this.pinService.validatePin$
    .pipe(untilDestroyed(this))
    .subscribe(res => {
      if (res?.dialogId === this.enableC3toC5DrugsPinChannel && res?.success) {
        this.handleDrugsSwitch(res.pin);
      } else if (res?.dialogId === this.editDrugsOfInterestPinChannel && res?.success) {
        this.saveUpdatedDrugsOfInterestList(res.pin);
      }
    })
  }

  drugsToTrackSelected(selected): void {
    this.drugsOfInterest = selected;
    this.showPinDialog(
      this.editDrugsOfInterest ? this.editDrugsOfInterestPinChannel : this.enableC3toC5DrugsPinChannel
    );
  }

  onEnableC3toC5DrugsToggleClick(): void {
    if (this.store.selectSnapshot(PharmacyState.enableC3toC5Drugs)) {
     this.showPinDialog(this.enableC3toC5DrugsPinChannel);
    } else {
      this.getDrugsOfInterest();
    }
  }

  handleDrugsSwitch(pin: number): void {
    this.store
      .dispatch(new EnableC3toC5Drugs(pin, this.drugsOfInterest))
      .pipe(untilDestroyed(this))
      .subscribe((_) => {
        this.afterDrugsOfInterestSaved();
      });
  }

  saveUpdatedDrugsOfInterestList(pin: number): void {
    this.store
      .dispatch(new UpdateDrugsToTrack(pin, this.drugsOfInterest.DrugsOfInterestValue))
      .pipe(untilDestroyed(this))
      .subscribe((_) => {
        this.afterDrugsOfInterestSaved();
      });
  }

  edit(): void {
   this.getDrugsOfInterest(true);
  }

  getAllDrugDescriptionExtension(): string {
    const n = this.store.selectSnapshot(PharmacyState.enableC3toC5DrugsValue).DrugsOfInterestValue?.length;
    return `and ${n} drug${n != 1 ? 's' : ''} of interest`;
  }

  private getDrugsOfInterest(isUpdate: boolean = false) {
    if (this.store.selectSnapshot(SettingsState?.drugsOfInterest)?.length) {
      this.editDrugsOfInterest = isUpdate;
      this.runEnableC3C5Workflow = true;
      return;
    }
    this.store.dispatch(new GetDrugsOfInterest(isUpdate ? DrugActivitiesToTrackEnum.AllAndDrugsOfInterest : null))
    .pipe(untilDestroyed(this))
    .subscribe(() => {
      this.editDrugsOfInterest = isUpdate;
      this.runEnableC3C5Workflow = true;
    });
  }

  private showPinDialog(channel: string): void {
    this.runEnableC3C5Workflow = false;
    this.pinService.openPinDialog(channel);
  }

  private afterDrugsOfInterestSaved(): void {
    const dashboardFilters = {
      ...this.store.selectSnapshot(TransactionsState)?.dashboardFilters,
    };
    dashboardFilters.schedules = null;
    this.store.dispatch(new SetDashboardFilters(dashboardFilters));
    this.drugsService.clearDrugs();
    this.runEnableC3C5Workflow = false;
    this.pinService.closeDialog();
  }
  
}
